import { useEffect, useState } from "react";
import { Smartphone, Share, PlusSquare, MoreVertical } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { isStandalone, isIOS, canPrompt, promptInstall, onPwaChange } from "@/lib/pwa";

function Step({ n, children }) {
  return (
    <div className="flex items-start gap-3">
      <span className="h-6 w-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center shrink-0">{n}</span>
      <div className="text-sm text-slate-300 pt-0.5">{children}</div>
    </div>
  );
}

export function InstallApp() {
  const [, force] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => onPwaChange(() => force((x) => x + 1)), []);
  if (isStandalone()) return null;
  const click = async () => { if (canPrompt()) await promptInstall(); else setHelp(true); };
  return (
    <>
      <button onClick={click} data-testid="install-app-btn"
              className="w-full mb-2 flex items-center justify-center gap-2 rounded-lg border border-blue-500/40 bg-blue-600/15 text-blue-200 text-sm font-semibold py-2 hover:bg-blue-600/25 transition-colors">
        <Smartphone size={15} /> Uygulamayı Yükle
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-sm" data-testid="install-help">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Smartphone size={18} className="text-blue-300" /> Telefona Uygulama Olarak Ekle</DialogTitle></DialogHeader>
          {isIOS() ? (
            <div className="space-y-3">
              <Step n={1}>Safari'de alttaki <Share size={14} className="inline -mt-1 text-blue-300" /> <b>Paylaş</b> düğmesine dokunun.</Step>
              <Step n={2}><PlusSquare size={14} className="inline -mt-1 text-blue-300" /> <b>Ana Ekrana Ekle</b>'yi seçin.</Step>
              <Step n={3}>Sağ üstten <b>Ekle</b>'ye dokunun. Uygulama ana ekranda “Karahan” adıyla görünür.</Step>
            </div>
          ) : (
            <div className="space-y-3">
              <Step n={1}>Chrome'da sağ üstteki <MoreVertical size={14} className="inline -mt-1 text-blue-300" /> menüye dokunun.</Step>
              <Step n={2}><b>Uygulamayı yükle</b> veya <b>Ana ekrana ekle</b>'yi seçin.</Step>
              <Step n={3}><b>Yükle</b>'ye dokunun. Uygulama ana ekranda “Karahan” adıyla görünür.</Step>
            </div>
          )}
          <p className="text-xs text-slate-500">Web'de yapılan her güncelleme uygulamaya otomatik yansır; ayrıca güncelleme indirmeniz gerekmez.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
